export default {
    ADD_DISTRIBUTOR(state, distributor) {
      state.distributors.unshift(distributor);
      state.totalDataRow++;
    },
    SET_DISTRIBUTOR(state, res) {
      state.distributors = res.items
      state.totalDataRow = res.totalCount;
    },
    UPDATE_DISTRIBUTOR(state, distributor) {
      const distributorIndex = state.distributors.findIndex((p) => p.id == distributor.id)
      Object.assign(state.distributors[distributorIndex], distributor)
    },
    REMOVE_DISTRIBUTOR(state, distributorId) {
      const distributorIndex = state.distributors.findIndex((p) => p.id == distributorId)
      state.distributors.splice(distributorIndex, 1)
    },
  }
  